import { parsePhoneNumberWithError } from 'libphonenumber-js';

const DEFAULT_PHONE_COUNTRY = 'GB';

export const PHONE_NUMBER_VALIDATION_EXAMPLE =
  'Use an international number such as +447564000000, or a UK number such as 01732000000.';

export function formatPhoneNumberForApi(phone?: string | null): string | null {
  const trimmedPhone = phone?.trim();

  if (!trimmedPhone) {
    return null;
  }

  try {
    const parsedPhone = parsePhoneNumberWithError(
      trimmedPhone,
      DEFAULT_PHONE_COUNTRY,
    );

    if (!parsedPhone.isValid()) {
      return null;
    }

    return parsedPhone.format('E.164');
  } catch (_error) {
    return null;
  }
}

export function isValidPhoneNumberForForm(phone?: string | null): boolean {
  return !phone?.trim() || formatPhoneNumberForApi(phone) !== null;
}
